import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { P } from '../../../theme/tokens';

// Short "MMM D" label from an ISO date (YYYY-MM-DD), timezone-safe (no Date parsing).
function dayLabel(iso) {
  const [, m, d] = iso.split('-').map(Number);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[m - 1]} ${d}`;
}

const tickStyle = { fontSize: 11, fill: P.subtle };

// Calls-per-day. ResponsiveContainer + minTickGap keep the axis readable at any
// width, which is what the cramped design mock could not do.
export default function DailyBars({ series = [], height = 260 }) {
  const data = series.map((s) => ({ date: dayLabel(s._id), calls: s.calls }));

  if (!data.length) return null;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }} barCategoryGap="20%">
        <CartesianGrid vertical={false} stroke={P.line} />
        <XAxis
          dataKey="date"
          tick={tickStyle}
          tickLine={false}
          axisLine={{ stroke: P.border }}
          minTickGap={16}
          interval="preserveStartEnd"
        />
        <YAxis tick={tickStyle} tickLine={false} axisLine={false} allowDecimals={false} width={32} />
        <Tooltip
          cursor={{ fill: P.rowHover }}
          contentStyle={{ borderRadius: 8, border: `1px solid ${P.border}`, fontSize: 13 }}
          labelStyle={{ fontWeight: 600, color: P.ink }}
          formatter={(v) => [v, 'Calls']}
        />
        <Bar dataKey="calls" fill={P.navy} radius={[4, 4, 0, 0]} maxBarSize={28} />
      </BarChart>
    </ResponsiveContainer>
  );
}
